/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { SEO } from "@/components/SEO";
import { SpecLabel } from "@/components/Section";

export default function PrivacyPage() {
    return (
        <>
            <SEO
                title="Privacy Policy"
                description="How Elevara Systems collects, uses, and protects your information. Last updated June 8, 2026."
                path="/privacy"
                noindex
            />
            <div
                className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16"
                data-testid="privacy-page"
            >
                <SpecLabel>Legal</SpecLabel>
                <h1 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#0a0b0d]">
                    Privacy Policy
                </h1>
                <p className="mt-3 text-sm text-[#4a5562] font-display font-bold uppercase tracking-[0.18em]">
                    Last updated: June 8, 2026
                </p>
            </div>
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
                <article
                    data-testid="legal-content"
                    className="rounded-2xl border-2 border-[#0a0b0d]/8 bg-white p-6 sm:p-10 lg:p-14 max-w-4xl mx-auto leading-relaxed text-[#0a0b0d]"
                >
                    <h2 className="font-display text-2xl font-extrabold mt-0">1. Overview</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Elevara Systems (“we,” “us,” “our”) operates
                        theelevara.com. This policy explains how we collect,
                        use, and protect your information.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">2. Information We Collect</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Name, email address, phone number, business name, and
                        website usage data (IP address, browser type, pages
                        visited).
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">3. SMS / Text Message Communications</h2>
                    <p className="mt-3 text-[#4a5562]">
                        By providing your phone number and opting in, you
                        consent to receive text messages from Elevara Systems
                        including service updates, marketing messages, and
                        follow-ups. Message frequency varies. Message and
                        data rates may apply. Reply STOP to opt out. Reply
                        HELP for assistance or contact contact@theelevara.com.
                        We do not share your phone number or mobile opt-in
                        data with third parties for their marketing purposes.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">4. How We Use Your Information</h2>
                    <p className="mt-3 text-[#4a5562]">
                        To provide and maintain our services, communicate
                        about your account, send marketing communications
                        (with consent), improve our website, and comply with
                        legal obligations.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">5. Third-Party Services</h2>
                    <p className="mt-3 text-[#4a5562]">
                        We use GoHighLevel (CRM and automation), Mailgun
                        (email delivery), and Google Analytics (website
                        analytics). Each has their own privacy policy.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">6. Cookies</h2>
                    <p className="mt-3 text-[#4a5562]">
                        We use cookies to improve your experience. You can
                        control settings through your browser.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">7. Data Security</h2>
                    <p className="mt-3 text-[#4a5562]">
                        We implement appropriate security measures. No
                        internet transmission is 100% secure.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">8. Your Rights</h2>
                    <p className="mt-3 text-[#4a5562]">
                        You may access, correct, or request deletion of your
                        data and opt out of marketing at any time.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">9. Children's Privacy</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Our services are not directed to individuals under
                        18.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">10. Changes</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Updates will be posted on this page with a new date.
                    </p>

                    <h2 className="font-display text-2xl font-extrabold mt-10">11. Contact</h2>
                    <p className="mt-3 text-[#4a5562]">
                        Elevara Systems |{" "}
                        <a
                            href="mailto:contact@theelevara.com"
                            className="text-[#188bf6] font-display font-bold hover:underline"
                        >
                            contact@theelevara.com
                        </a>{" "}
                        |{" "}
                        <a
                            href="tel:+19418075580"
                            className="text-[#188bf6] font-display font-bold hover:underline"
                        >
                            941-807-5580
                        </a>
                    </p>
                </article>
            </div>
        </>
    );
}
